import { lazy } from 'react';

export const ForgotPasswordPageLazy = lazy(
    () => import('./forgot-password-page'),
);
